export default "__VITE_ASSET__aRhPs1vX__"